import React from "react";
import { CommandBar } from "@fluentui/react";
export function Footer() {
  return (
    <div className="ms-Grid-row" style={{ backgroundColor: "transparent" }}>
      <div className="ms-Grid-col ms-sm12">
        <CommandBar items={getItems()} />
      </div>
    </div>
  );

  function getItems() {
    return [
      {
        key: "newItem",
        name: "System Integration API",
        cacheKey: "myCacheKey", // changing this key will invalidate this items cache
        iconProps: {
          iconName: "Sync",
        },
        ariaLabel: "New",
        subMenuProps: {
          items: [
            {
              key: "emailMessage",
              name: "Mobile Integration",
              iconProps: {
                iconName: "CellPhone",
              },
            },
            {
              key: "calendarEvent",
              name: "Web Integration",
              iconProps: {
                iconName: "Globe",
              },
            },
          ],
        },
      },
      {
        key: "upload",
        name: "Training Documents",
        iconProps: {
          iconName: "PowerPointLogo",
        },
        href: "https://cybersprint.com",
      },
      {
        key: "share",
        name: "Training Videos",
        iconProps: {
          iconName: "Video",
        },

        onClick: () => console.log("Share"),
      },
      {
        key: "download",
        name: "Training Manual",
        iconProps: {
          iconName: "BookOpen",
        },
        onClick: () => console.log("Download"),
      },
      {
        key: "support",
        name: "Support",
        iconProps: {
          iconName: "Phone",
        },
        onClick: () => console.log("Download"),
      },
      {
        key: "credits",
        name: "Credits",
        iconProps: {
          iconName: "CheckMark",
        },
        onClick: () => console.log("Download"),
      },
    ];
  }
}

